export function IconMetadata() {
    return (
        <svg width="12" height="13" viewBox="0 0 12 13">
            <path fill="currentColor" d="M2.5 1.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h2a.75.75 0 0 0 0-1.5H2.75v-6.5H4.5a.75.75 0 0 0 0-1.5h-2zm5 0a.75.75 0 0 0 0 1.5h1.75v6.5H7.5a.75.75 0 0 0 0 1.5h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-2z"/>
        </svg>
    );
}
